import '@regulaforensics/vp-frontend-face-components';
import { SelfieStepProps } from './types';
import { useSelfieStep } from './hooks/use-selfie-step/use-selfie-step';

export const SelfieStep = ({ onSuccess }: SelfieStepProps) => {
  const { elementRef } = useSelfieStep(onSuccess);

  return <face-capture ref={elementRef} />;
};
